import React from 'react';

interface StepIconProps {
  size?: number;
  className?: string;
}

const StepIcon: React.FC<StepIconProps> = ({ 
  size = 12, 
  className = '' 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 12 12" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M2.5 4.5V8" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M2.625 4.25C1.72754 4.25 1 3.52246 1 2.625C1 1.72754 1.72754 1 2.625 1C3.52246 1 4.25 1.72754 4.25 2.625C4.25 3.52246 3.52246 4.25 2.625 4.25Z" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M2.5 11C1.67157 11 1 10.3284 1 9.5C1 8.67157 1.67157 8 2.5 8C3.32843 8 4 8.67157 4 9.5C4 10.3284 3.32843 11 2.5 11Z" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5C11 10.3284 10.3284 11 9.5 11Z" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M2.56494 4.5C2.78994 5.375 3.58994 6.025 4.53494 6.02L6.24994 6.015C7.55994 6.01 8.67494 6.85 9.08494 8.02" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StepIcon;